export { getHostedModuleCodeSnippetLanguage } from './getHostedModuleCodeSnippetLanguage'
export {
  getCodeSnippetLanguage,
  TECHNOLOGIES,
  TECHNOLOGY_CONFIGURATIONS,
  TECHNOLOGY_CROSS_GRAFT_LIBRARY_IMPORTS,
  TECHNOLOGY_ENDPOINT_PREFIXES,
  TECHNOLOGY_FIELD_USAGES,
  TECHNOLOGY_IMPORTS,
  TECHNOLOGY_INSTANCES,
  TECHNOLOGY_LIBRARY_IMPORTS,
  TECHNOLOGY_USAGES,
  TECHNOLOGY_VARIABLES,
} from './technologies'
